export default function IconLogout({ color = '#EB4335', width = 48, height = 48, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='48' height='48' rx='16' fill={color} fillOpacity='0.1' />
      <path
        d='M14.1998 12.1C13.4266 12.1 12.7998 12.8611 12.7998 13.8V34.2C12.7998 35.1389 13.4266 35.9 14.1998 35.9C14.973 35.9 15.5998 35.1389 15.5998 34.2V13.8C15.5998 12.8611 14.973 12.1 14.1998 12.1Z'
        fill={color}
      />
      <path
        d='M28.6099 27.8979C28.0631 28.5618 28.0631 29.6382 28.6099 30.3021C29.1566 30.9659 30.043 30.9659 30.5898 30.3021L34.7898 25.2021C35.0523 24.8832 35.1998 24.4508 35.1998 24C35.1998 23.5491 35.0523 23.1167 34.7898 22.7979L30.5898 17.6979C30.043 17.034 29.1566 17.034 28.6099 17.6979C28.0631 18.3618 28.0631 19.4382 28.6099 20.1021L30.4199 22.3H19.7998C19.0266 22.3 18.3998 23.0611 18.3998 24C18.3998 24.9389 19.0266 25.7 19.7998 25.7H30.4199L28.6099 27.8979Z'
        fill={color}
      />
    </svg>
  );
}
